import habitat from "preact-habitat";

import { App } from "./component";

const _habitat = habitat(App);

_habitat.render({
  selector: '[data-widget-host="habitat"]',
  clean: true,
});
